function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M78.846 135.921V74.128h21.332l3.194-24.082H78.846V34.672c0-6.973 1.991-11.724 12.274-11.724l13.115-.006V1.403c-2.268-.293-10.053-.95-19.111-.95-18.91 0-31.856 11.224-31.856 31.834v17.76H31.882v24.082h21.386v61.793z",
  fill: "#000"
});

function SvgFacebookSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 135.47 135.47"
  }, props), _ref);
}

export default SvgFacebookSquare;